import { RouteRecordRaw } from "vue-router";
import { eGuaranteeTypes } from "@ntprsrf-frontend/internet/src/constants/APIEnums";

const ALL_SETTINGS_ACCESS_TYPES = [
  eGuaranteeTypes.NORMAL.VALUE,
  eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
  eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
];

const SFTP_SETTINGS_ACCESS_TYPES = [
  eGuaranteeTypes.NORMAL.VALUE,
  eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
];

const settingsRoutes: RouteRecordRaw[] = [
  {
    component: () => import("@/views/Settings/Settings.vue"),
    path: "settings",
    name: "SETTINGS",
    redirect: () => {
      return {
        name: "PERSONAL_SETTINGS",
      };
    },
    meta: {
      label: "Settings",
      rebrand: true,
      eGuaranteeTypesCanAccess: ALL_SETTINGS_ACCESS_TYPES,
      breadcrumb: (route: RouteRecordRaw) => ({
        label: route.meta?.customBreadcrumb ?? "Settings",
        title: route.meta?.breadcrumbTitle ?? "Settings",
        to: { name: "SETTINGS" },
      }),
    },
    children: [
      {
        path: "personal",
        name: "PERSONAL_SETTINGS",
        component: () => import("@/views/Settings/PersonalSettings.vue"),
        meta: {
          label: "Personal",
          rebrand: true,
          eGuaranteeTypesCanAccess: ALL_SETTINGS_ACCESS_TYPES,
          hideBreadcrumb: true,
        },
      },
      {
        path: "api-connection",
        name: "API_SETTINGS",
        component: () => import("@/views/DataSettings/APIConnection.vue"),
        meta: {
          label: "API Settings",
          rebrand: true,
          eGuaranteeTypesCanAccess: ALL_SETTINGS_ACCESS_TYPES,
          hideBreadcrumb: true,
        },
      },
      {
        path: "sftp-connection",
        name: "SFTP_SETTINGS",
        component: () => import("@/views/DataSettings/SFTPConnection.vue"),
        meta: {
          label: "SFTP",
          rebrand: true,
          eGuaranteeTypesCanAccess: SFTP_SETTINGS_ACCESS_TYPES,
          hideBreadcrumb: true,
        },
        redirect: () => {
          return {
            name: "SFTP_ACCOUNT",
          };
        },
        children: [
          {
            name: "SFTP_ACCOUNT",
            path: "account",
            meta: {
              label: "Account",
              rebrand: true,
              eGuaranteeTypesCanAccess: SFTP_SETTINGS_ACCESS_TYPES,
              hideBreadcrumb: true,
            },
            component: () => import("@/views/DataSettings/Account.vue"),
          },
        ],
      },
    ],
  },
];

export default settingsRoutes;
